module.exports = __webpack_public_path__ + "static/media/img-e129c6ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/aayuwell-logo.png
// module id = 5274
// module chunks = 39